import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { format, FORMAT } from "commons/src/NuDateUtils";
import { convertToMoney } from "commons/src/Money";

export function MemoAsset({ asset }) {
    const getField = (name, description) => {
        return (
            <div data-testid="asset-field-details">
                <FieldInternalP>{name}</FieldInternalP>
                <FieldInternalP>
                    <span>{description || " - "}</span>
                </FieldInternalP>
            </div>
        );
    };

    const convertedValue = convertToMoney(asset.approximateValue);

    return (
        <AssetBlock key={asset.planNumber} data-testid="memo-asset">
            {getField("Description", asset.description)}
            {getField("Plan number", asset.planNumber)}
            {getField("Institution", asset.institution)}
            {getField("Approx value", convertedValue)}
            {getField("Valuation date", format(asset.valueEffectiveDate, FORMAT.SLASH_SEPARATED))}
        </AssetBlock>
    );
}

export const AssetBlock = styled.div`
    font-size: 1em;
    background: #fff;
    flex: 0 0 48%;
    @media (max-width: ${props => props.theme.maxWidth}) {
        flex-basis: 100%;
    }
    padding: 1.5em 2.5em 1.5em 1.5em;
    margin: 1%;
`;

export const FieldInternalP = styled.p`
    width: 49%;
    display: inline-block;
    :nth-child(1) {
        text-align: left;
    }
    :nth-child(2) {
        text-align: right;
    }
`;

MemoAsset.propTypes = {
    asset: PropTypes.shape({
        description: PropTypes.string,
        planNumber: PropTypes.string,
        institution: PropTypes.string,
        approximateValue: PropTypes.number,
        valueEffectiveDate: PropTypes.string
    })
};
